/**
 * Stellt Helfermethoden für Mischen eines Array bereit.
 *
 * @class service_v3sArrayService
 * @memberOf v3sWbtPlayerApp:helper
 */
angular.module('v3sWbtPlayerApp').factory('v3sArrayService', function () {

    /**
     * Mischt den Array.
     * @memberOf v3sWbtPlayerApp:helper.service_v3sArrayService
     * @param {array} array zu mischender Array
     * @param {boolean} copy wenn true, wird eine Kopie des Arrays angelegt
     * @param {string} order wenn "random", wird Array zufällig gemischt
     */
    function shuffle(array, copy, order) {
        if (copy) {
            array = array.slice();
        }

        if (order == "random") {
            for (var i = array.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                var temp = array[i];
                array[i] = array[j];
                array[j] = temp;
            }
        }

        return array;
    }

    return {
        shuffle: shuffle
    }
});